import { API, graphqlOperation } from "aws-amplify";

import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { CompanyUpdateForm as ACompanyUpdateForm } from "ui-components/index";
import { getCompany } from "graphql/queries";
import { customListCompaniesByNit } from "graphql/custom-queries";

const CompanyUpdateForm = ({ companyId, onSuccess }) => {
  const navigate = useNavigate();
  const [company, setCompany] = useState();

  const onValidateNit = {
    nit: async (value, validationResponse) => {
      if (value) {
        const lastIndex = value.lastIndexOf("-");
        const resultValue =
          lastIndex !== -1 ? value.substring(0, lastIndex) : value;

        if (!company.nit.includes(resultValue)) {
          const companiesData = await API.graphql(
            graphqlOperation(customListCompaniesByNit, {
              filter: {
                nit: { contains: resultValue },
              },
            })
          );
          const companiesItems = companiesData.data.listCompanies.items ?? [];
          if (companiesItems.length > 0) {
            return {
              hasError: true,
              errorMessage: strings.validations.nit,
            };
          }
        }
      }
      return validationResponse;
    },
  };


  const onSuccessForm = () => {
    toast.success(strings.successUpdated);
    if (onSuccess) onSuccess();
    else navigate("/companies");
  };
  const onError = (_model, error) => toast.error(error);

  async function fetchCompany(id) {
    try {
      const companyData = await API.graphql(
        graphqlOperation(getCompany, { id })
      );
      const companyItem = companyData.data.getCompany;
      if (!companyItem) {
        toast.error(strings.responses.errorFetch);
        if (onSuccess) onSuccess();
        else navigate("/companies");
        return;
      }
      setCompany(companyItem);
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchCompany(companyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div>
      <ACompanyUpdateForm
        company={company}
        overrides={{
          name: {
            label: (
              <span>
                {strings.fields.name}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          nit: {
            label: (
              <span>
                {strings.fields.nit}
                <span style={{ fontSize: "0.8rem", color: "red" }}>{" *"}</span>
              </span>
            ),
          },
          abbreviation: {
            label: strings.fields.abbreviation,
          },
          address: {
            label: strings.fields.address,
          },
          phone: {
            label: strings.fields.phone,
          },
          country: {
            label: strings.fields.country,
          },
          city: {
            label: strings.fields.city,
          },
          description: {
            label: strings.fields.description,
          },
          legalRepName: {
            label: strings.fields.legalRepName,
          },
          legalRepContact: {
            label: strings.fields.legalRepContact,
          },
          otherContacts: {
            label: strings.fields.otherContacts,
          },
          ResetButton: {
            children: strings.reset,
          },
          SubmitButton: {
            children: strings.update,
          },
        }}
        onValidate={onValidateNit}
        onSuccess={onSuccessForm}
        onError={onError}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Empresa",
    reset: "Restablecer",
    update: "Actualizar",
    successUpdated: "Empresa actualizada con éxito",
    responses: {
      errorFetch: "Error al consultar la empresa",
    },
    fields: {
      name: "Nombre Empresa",
      nit: "Nit",
      abbreviation: "Abreviatura",
      address: "Dirección principal",
      phone: "Teléfono",
      country: "País",
      city: "Ciudad",
      description: "Descripción",
      legalRepName: "Nombre del Representante Legal",
      legalRepContact: "Contacto del Representante Legal",
      otherContacts: "Otros contactos",
    },
    validations: {
      nit: "El nit ingresado ya existe",
    },
  },
});

export default CompanyUpdateForm;
